<template>
  <div id="subjectprepare" class="mx-2">
    <br />
    <div
      align="center"
      :class="{  'h5': $vuetify.breakpoint.mdAndDown, 'h4': $vuetify.breakpoint.lgAndUp,  }"
    >{{ $route.params.name != null ? $route.params.name + " - Topics": this.name + " - Topics" }}</div>
    <br />
    <v-container>
      <v-flex align-center justify-center class="mx-0 my-0 py-0">
        <v-layout v-for="quiz in prep" :key="quiz.id">
          <v-flex ma-2 align-center justify-center>
            <router-link :to="{ name:'SubjectSubTopics', params: { id2: quiz.id , topic: quiz.topic} }" style="text-decoration: none;">
              <v-card class="my-0 py-0">
                <v-card-title
                  class="pa-2 mx-5"
                  :class="{  'subtitle-2': $vuetify.breakpoint.mdAndDown, 'h5': $vuetify.breakpoint.lgAndUp,  }"
                >
                  <span>{{ quiz.topic }}</span>
                  <v-spacer></v-spacer>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-card-title>
              </v-card>
            </router-link>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
    <br />
    <br />
  </div>
</template>

<script>
import db from "@/fb";

export default {
  data() {
    return {
      prep: [],
      name: "",
    };
  },

  created() {
    var id = this.$route.params.id;
    var name = this.$route.params.name;
    //console.log(id);

    if (name == null) {
      //console.log('Null hai');
      let ref = db.collection("Subjects").doc(id);
      ref.get().then((snapshot) => {
        if (snapshot.exists) {
          var post = snapshot.data();
          this.name = post["Name"];
        } else {
          console.log("No such document!");
        }
      });
    }

    db.collection("Subjects")
      .doc(id)
      .collection("Prepare")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            //topic: this.count += 1 ,
            topic: doc.data().name,
          };
          this.prep.push(data);
        });
      });
  },
  methods: {
    refresh() {
      var id = this.$route.params.id;
      this.prep = [];
      this.count = 0;

      db.collection("Subjects")
        .doc(id)
        .collection("Prepare")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              quesno: (this.count += 1),
              topic: doc.data().name,
            };
            this.prep.push(data);
          });
        });
    },
  },
};
</script>



<style lang="scss" scoped>

a {
    text-decoration: none;
}

</style>